/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react"
import apiCall from "utils/api"
import { formatPhoneNumber } from "utils/format"
import fileDownload from "js-file-download"
import { Squares } from "react-activity"
import "react-activity/dist/react-activity.css"

import qrcode from "assets/qrcode.png"

const QRCodeButton = ({ lobbyId, phoneNumber }) => {

  const [loading, setLoading] = useState(false)

  const formattedPhoneNumber = formatPhoneNumber(phoneNumber, true)

  const downloadQRCode = e => {
    e.preventDefault()
    if(loading) return
    setLoading(true)
    apiCall("get", `lobbies/${lobbyId}/qrcode`, {}, "arraybuffer")
    .then(response => {
      fileDownload(
        response.data,
        `awaiting-qr-code-${formattedPhoneNumber}.png`,
        "image/png",
      )
      setLoading(false)
    }).catch(error => {
      console.error(error.message)
      setLoading(false)
    })
  }

  return (
    <div className={`download-button ${loading ? "loading" : ""}`}  onClick={downloadQRCode}>
      <div className="download-image">
        <img src={qrcode} alt="QR Code" />
      </div>
      <span className="download-text">Download QR Code</span>
      <span className="loading">{loading && <Squares />}</span>
    </div>
  )
}

export default QRCodeButton
